/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import Link from '@salesforce/retail-react-app/app/components/link';
// Project Components
import {
  AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Heading, Stack, Text,
} from '@salesforce/retail-react-app/app/components/shared/ui';
// Others
import {noop} from '@salesforce/retail-react-app/app/utils/utils';

const CategoryLinks = ({category = {}, onSelect = noop}) => {
  const {categories = []} = category;

  return (
    <AccordionItem key="show-all" borderTop="none" paddingBottom={6}>
      <AccordionButton>
        <Heading as="h2" flex="1" fontSize="md" fontWeight={600} textAlign="left">
          <FormattedMessage defaultMessage="Categories" id="category_links.button_text" />
        </Heading>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <Stack spacing={1}>
          {categories.map(({id, name}) => {
            return (
              <Link
                key={id}
                alignItems="center"
                display="flex"
                href={`/category/${id}`}
                lineHeight={{base: '44px', lg: '24px'}}
                useNavLink
                onClick={onSelect}
              >
                <Text fontSize="sm">{name}</Text>
              </Link>
            );
          })}
        </Stack>
      </AccordionPanel>
    </AccordionItem>
  );
};

CategoryLinks.propTypes = {
  category: PropTypes.object,
  onSelect: PropTypes.func,
};

export default CategoryLinks;
